export default "__VITE_ASSET__483d8175__"